import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/qrcode_white.svg'
import _imports_1 from '@/assets/icons/message.svg'
import _imports_2 from '@/assets/icons/ticket_white.svg'


const _withScopeId = n => (_pushScopeId("data-v-01f15050"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return ($setup.bookRequiredType === $setup.BookRequiredType.NO_BOOK_REQUIRED)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        ($setup.serviceInfo?.boardCheckCode === $setup.BoardCheckCode.QRTAG)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              class: "btn-qr",
              to: { name: $setup.RouterName.MobileId },
              "aria-label": "모바일 ID 화면으로 이동"
            }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["to"]))
          : (_openBlock(), _createBlock(_component_router_link, {
              key: 1,
              class: "btn-chat",
              to: {
        name: $setup.RouterName.Chat,
        query: {
          loginId: $setup.userInfo?.loginId,
          name: $setup.userInfo?.alias,
          phone: $setup.userInfo?.phone,
          email: $setup.userInfo?.email,
          clientName: $setup.userInfo?.clientName,
        },
      },
              "aria-label": "챗봇 문의 페이지로 이동"
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["to"]))
      ], 64 /* STABLE_FRAGMENT */))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        (
        $setup.bookRequiredType === $setup.BookRequiredType.BOOK_REQUIRED ||
        $setup.bookRequiredType === $setup.BookRequiredType.MIXED
      )
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              class: "btn-ticket",
              to: 
        $setup.bookRequiredType === $setup.BookRequiredType.BOOK_REQUIRED
          ? { name: $setup.RouterName.BookHistory }
          : $setup.bookRequiredType === $setup.BookRequiredType.MIXED
          ? { name: $setup.RouterName.BookBoardHistory }
          : {}
      ,
              "aria-label": $setup.ticketBtnLabel
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["to", "aria-label"]))
          : _createCommentVNode("v-if", true)
      ], 64 /* STABLE_FRAGMENT */))
}